import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

class SwiperModule  {

  constructor () {
    this._swipers = []
    this.initSwipers(document.querySelectorAll('.js-swiper'))
  }

  initSwipers (sw) {
    for (let i = 0; i < sw.length; i++) {
      let swiperContainer = sw[i].querySelector('.swiper-container')
      let swiperPagination = sw[i].querySelector('.swiper-pagination')
      let swiperButtonPrev = sw[i].querySelector('.js-swiper-button-prev')
      let swiperButtonNext = sw[i].querySelector('.js-swiper-button-next')
      let swiper = new Swiper(swiperContainer, {
        modules: [Navigation, Pagination],
        spaceBetween: 15,
        slidesPerView: 1,
        autoPlay: false,
        centeredSlides: true,
        speed: 500,
        loop: true,
        controlInverse: true,
        autoHeight: false,
        simulateTouch: true,
        watchOverflow: true,
        pagination: {
          el: swiperPagination,
          clickable: true
        },
        navigation: {
          nextEl: swiperButtonNext,
          prevEl: swiperButtonPrev
        },
        breakpoints: {
          700: {
            speed: 300
          }
        }
      })
      this._swipers.push(swiper)
    }
  }
}

export default new SwiperModule()
